import { IApiPage } from '../api'
import { createGlobalContext } from '../registry'

export const PageContext = createGlobalContext<{ page?: IApiPage }>(
  'PageContext',
  { page: undefined },
)
